__turbopack_context__.v({
  "ManualSearch": "zNNVvG_ManualSearch",
  "ManualSearch__Chapter": "zNNVvG_ManualSearch__Chapter",
  "ManualSearch__Clear": "zNNVvG_ManualSearch__Clear",
  "ManualSearch__Empty": "zNNVvG_ManualSearch__Empty",
  "ManualSearch__Field": "zNNVvG_ManualSearch__Field",
  "ManualSearch__Icon": "zNNVvG_ManualSearch__Icon",
  "ManualSearch__Input": "zNNVvG_ManualSearch__Input",
  "ManualSearch__Mark": "zNNVvG_ManualSearch__Mark",
  "ManualSearch__Panel": "zNNVvG_ManualSearch__Panel",
  "ManualSearch__Result": "zNNVvG_ManualSearch__Result",
  "ManualSearch__Result--Active": "zNNVvG_ManualSearch__Result--Active",
  "ManualSearch__ResultIcon": "zNNVvG_ManualSearch__ResultIcon",
  "ManualSearch__Results": "zNNVvG_ManualSearch__Results",
  "ManualSearch__Section": "zNNVvG_ManualSearch__Section",
  "ManualSearch__Snippet": "zNNVvG_ManualSearch__Snippet",
  "ManualSearch__Text": "zNNVvG_ManualSearch__Text",
  "ManualSearch__Total": "zNNVvG_ManualSearch__Total",
});
